<template>
  <div>
    <div class="main-content">
      <!-- Navbar -->
      <nav class="navbar navbar-top navbar-horizontal navbar-expand-md navbar-dark">
        <div class="container px-4">
          <router-link class="navbar-brand" :to="{ name: 'launchpad' }">
            <img src="https://s3-ap-southeast-2.amazonaws.com/resource.csnstatic.com/retail/globals/logo/v5/chileautos-white.png" width="70" />
          </router-link>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbar-collapse-main"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbar-collapse-main">
            <!-- Collapse header -->
            <div class="navbar-collapse-header d-md-none">
              <div class="row">
                <div class="col-6 collapse-brand">
                  <router-link :to="{ name: 'launchpad' }">
                    <img src="@/assets/img/logo.svg" />
                  </router-link>
                </div>
                <div class="col-6 collapse-close">
                  <button
                    type="button"
                    class="navbar-toggler"
                    data-toggle="collapse"
                    data-target="#navbar-collapse-main"
                    aria-controls="sidenav-main"
                    aria-expanded="false"
                    aria-label="Toggle sidenav"
                  >
                    <span></span>
                    <span></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <!-- Header -->
      <div class="header bg-gradient-primary py-7">
        <div class="container">
          <div class="header-body text-center mb-7">
            <div class="row justify-content-center">
              <div class="col-lg-5 col-md-6">
                <h1 class="text-white">Bienvenido</h1>
                <p class="text-lead text-light">Ingresa tus datos para conectarte</p>
              </div>
            </div>
          </div>
        </div>
        <div class="separator separator-bottom separator-skew zindex-100">
          <svg
            x="0"
            y="0"
            viewBox="0 0 2560 100"
            preserveAspectRatio="none"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon class="fill-default" points="2560 0 2560 100 0 100" />
          </svg>
        </div>
      </div>
      <!-- Page content -->
      <div class="container mt--8 pb-5">
        <div class="row justify-content-center">
          <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">
              <my-spinner :loading="loading" />
              <div class="card-body px-lg-5 py-lg-5">
                <form role="form" @submit.prevent="login()">
                  <div class="form-group mb-3">
                    <div class="input-group input-group-alternative">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="ni ni-email-83"></i>
                        </span>
                      </div>
                      <input
                        class="form-control"
                        placeholder="Correo electrónico"
                        type="email"
                        v-model="user.email"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input-group input-group-alternative">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="ni ni-lock-circle-open"></i>
                        </span>
                      </div>
                      <input
                        class="form-control"
                        placeholder="Contraseña"
                        type="password"
                        v-model="user.clave"
                      />
                    </div>
                  </div>
                  <!-- <div class="custom-control custom-control-alternative custom-checkbox">
                                    <input class="custom-control-input" id=" customCheckLogin" type="checkbox">
                                    <label class="custom-control-label" for=" customCheckLogin">
                                        <span class="text-muted">Recordar</span>
                                    </label>
                  </div>-->
                  <div class="text-center">
                    <button type="submit" class="btn btn-primary btn-block my-4">Iniciar sesión</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <footer class="py-5">
      <div class="container">
        <div class="row align-items-center justify-content-xl-between">
          <div class="col-xl-12">
            <div class="copyright text-center text-muted">
              &copy; {{year}}
              <a
                href="https://chileautos.cl"
                class="font-weight-bold ml-1"
                target="_blank"
              >Chileautos</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import UsersServices from "@/services/users.services";
import sysMsgs from "@/helpers/system.message";
import moment from "moment";
import Auth from "@/helpers/middleware";

export default {
  data() {
    return {
      loading: false,
      year: new Date().getFullYear(),
      user: {
        email: null,
        clave: null
      }
    };
  },
  created() {},
  methods: {
    login() {
      this.loading = true;
      UsersServices.login
        .get(this.user)
        .then(response => {
          if (response.data.status.id == 1) {
            let dptos = JSON.parse(atob(response.data.secretKey));
            if (dptos.access) {
              Auth.logIn(response);
            } else {
              sysMsgs.getMessage(
                "Su cuenta no contiene departamentos asignados, favor de contactar con el administrador.",
                "error"
              );
              this.loading = false;
            }
          } else {
            sysMsgs.getMessage(
              "Su cuenta se encuentra bloqueada, favor de contactar con su departamento.",
              "error"
            );
            this.loading = false;
          }
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.loading = false;
        });
    }
  }
};
</script>
